import { render, staticRenderFns } from "./bhgGamesLayout.vue?vue&type=template&id=25be4c6b&"
import script from "./bhgGamesLayout.vue?vue&type=script&lang=js&"
export * from "./bhgGamesLayout.vue?vue&type=script&lang=js&"
import style0 from "./bhgGamesLayout.vue?vue&type=style&index=0&id=25be4c6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports